var isAnimating = false;
var closeHandlerInitialized = false;

function openWGDPopup() {
  var tooltipWrapper = document.querySelector('.cs-tooltip-wrapper');
  var tooltipTitle = document.querySelector('.cs-tooltip-title');
  var tooltipContent = document.querySelector('.cs-tooltip-content');
  
  if (!tooltipWrapper || !tooltipTitle || !tooltipContent) {
    return;
  }
  
  var popupTitle = 'In-Home Setup & Removal';
  var popupContent = '<div class="wgd-popup-content">' +
    '<p>This service is available only on certain eligible items, you can select it at checkout for an additional cost.</p>' +
    '<p>In-Home Setup & Removal is scheduled and conducted by Ryder, our service provider, and is available for new Bear mattresses. Please note that Ryder offers In-Home Setup service only for new Bear bases; removal service for old bases and bed frames is not currently available.</p>' +
    '<h3>How it works:</h3>' +
    '<ol style="margin: 15px; padding-left: 20px;">' +
    '<li>Once your items are ready, we’ll ship them to Ryder’s facility.</li>' +
    '<li>Ryder will contact you to schedule your In-Home Setup & Removal service.</li>' +
    '<li>On the scheduled delivery day, you’ll be notified when the Ryder team is about 30 minutes away.</li>' +
    '<li>Ryder will set up your purchase in the room of your choice and remove the old items being replaced. Note: removal service for old bases and bed frames is not currently available.</li>' +
    '</ol>' +
    '</div>';

  tooltipTitle.textContent = popupTitle;
  tooltipContent.innerHTML = popupContent;
  
  // Add custom class to wrapper
  tooltipWrapper.classList.add('wgd-popup');
  
  tooltipWrapper.style.display = 'block';
  tooltipWrapper.style.opacity = '1';
  document.body.style.overflow = 'hidden';
  isAnimating = false;
}

function closeWGDPopup() {
  var tooltipWrapper = document.querySelector('.cs-tooltip-wrapper');
  
  if (!tooltipWrapper || isAnimating) {
    return;
  }
  
  isAnimating = true;
  tooltipWrapper.style.display = 'none';
  tooltipWrapper.style.opacity = '1';
  document.body.style.overflow = 'auto';
  
  setTimeout(function() {
    isAnimating = false;
  }, 100);
}

function initWGDPopupCloseHandlers() {
  if (closeHandlerInitialized) {
    return;
  }
  
  closeHandlerInitialized = true;
  
  document.addEventListener('click', function(e) {
    var tooltipWrapper = document.querySelector('.cs-tooltip-wrapper');
    if (!tooltipWrapper) {
      return;
    }
    
    var computedStyle = window.getComputedStyle(tooltipWrapper);
    if (computedStyle.display === 'none' || isAnimating) {
      return;
    }
    
    if (e.target && (e.target.classList.contains('cs-tooltip-btn') || e.target.closest('.cs-tooltip-btn'))) {
      e.preventDefault();
      e.stopPropagation();
      closeWGDPopup();
      return false;
    }
    
    if (e.target && (e.target.classList.contains('close') || e.target.closest('.close'))) {
      e.preventDefault();
      e.stopPropagation();
      closeWGDPopup();
      return false;
    }
    
    if (e.target === tooltipWrapper) {
      closeWGDPopup();
      return false;
    }
  });
}

// Initialize close handlers when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWGDPopupCloseHandlers);
} else {
  initWGDPopupCloseHandlers();
}